import { UnifiedCompareState, ProductErrorState } from '../types';
import { Product } from 'common/components/product-card/types';
import { getCompareData } from '../api';

import { put, select, call, cancelled } from 'redux-saga/effects';

import { PRODUCTS_COMPARE_LOAD_DATA } from '../actions';
import { getRegion, getProductsCompareOrchestratorHost, getCustomerID } from 'common/selectors';
import { api } from 'api';
import { CancelTokenSource } from '@okapi/http';
import { checkCachedData, extractProductsFromResponse } from './utils/cache-utils';
import { getUnifiedCompareData } from '../selectors/base';

const PRODUCTS_SEPARATOR = ',';
const ERROR_CUSTOMER_NOT_FOUND = 'Customer ID не найден';
const ERROR_INVALID_PARAMS = 'Некорректные параметры запроса';

export function* fetchCompareDataSaga({
  payload: { groupId, productIds },
}: {
  payload: { groupId: string; productIds: string[] };
}): Generator {
  const abortController: CancelTokenSource = yield call([api, 'abortController']);
  try {
    if (!groupId || !productIds || productIds.length === 0) {
      throw new Error(ERROR_INVALID_PARAMS);
    }

    const customerId: string | null = yield select(getCustomerID);
    if (!customerId) {
      throw new Error(ERROR_CUSTOMER_NOT_FOUND);
    }

    const customHost: string = yield select(getProductsCompareOrchestratorHost);
    const regionCode: string = yield select(getRegion);
    const currentCompareState: UnifiedCompareState = yield select(getUnifiedCompareData);

    const currentGroup = currentCompareState?.[groupId];

    const cachedData: Record<string, Product> | null = checkCachedData(currentGroup, productIds);

    if (cachedData) {
      const successCachedData = {
        groupId,
        productsData: cachedData,
      };

      yield put(PRODUCTS_COMPARE_LOAD_DATA.success(successCachedData));
      return;
    }

    const compareDataResponse = yield call(
      getCompareData,
      customerId,
      groupId,
      regionCode,
      customHost,
      abortController.token,
    );
    const productsData = extractProductsFromResponse(compareDataResponse);

    const data = {
      groupId,
      productsData,
    };

    yield put(PRODUCTS_COMPARE_LOAD_DATA.success(data));
  } catch (error) {
    const err = error instanceof Error ? error : new Error(`Неизвестная ошибка: ${String(error)}`);

    const errorState: ProductErrorState = {
      error: err,
      productId: productIds ? productIds.join(PRODUCTS_SEPARATOR) : '',
      groupId,
    };

    yield put(PRODUCTS_COMPARE_LOAD_DATA.failure(errorState));

    const customerId: string | null = yield select(getCustomerID);
    // eslint-disable-next-line no-console
    console.error('Ошибка загрузки данных сравнения:', {
      message: err.message,
      stack: err.stack,
      groupId,
      productIds,
      customerId,
      timestamp: new Date().toISOString(),
    });
  } finally {
    if ((yield cancelled()) as boolean) abortController.cancel();
  }
}
